import React, { createContext, useContext, useEffect, useState } from 'react';
import { TPunishment } from '../utils/types';
import fetchPunishmentData from '../utils/fetchPunishmentData';

export enum NotApprovedPagePunishmentContextStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error'
}

type NotApprovedPagePunishmentContextState =
  | {
      status: NotApprovedPagePunishmentContextStatus.LOADING;
    }
  | {
      status: NotApprovedPagePunishmentContextStatus.SUCCESS;
      punishment: TPunishment | null;
    }
  | {
      status: NotApprovedPagePunishmentContextStatus.ERROR;
      error: unknown;
    };

export const NotApprovedPagePunishmentContext = createContext<NotApprovedPagePunishmentContextState>(
  {
    status: NotApprovedPagePunishmentContextStatus.ERROR,
    error: new Error('No context')
  }
);

export const useNotApprovedPagePunishmentContext = (): NotApprovedPagePunishmentContextState =>
  useContext(NotApprovedPagePunishmentContext);

const NotApprovedPagePunishmentProvider: React.FC = ({ children }) => {
  const [punishmentData, setPunishmentData] = useState<NotApprovedPagePunishmentContextState>({
    status: NotApprovedPagePunishmentContextStatus.LOADING
  });

  useEffect(() => {
    fetchPunishmentData().then(
      result => {
        setPunishmentData({
          status: NotApprovedPagePunishmentContextStatus.SUCCESS,
          punishment: result.data?.interventionId != null ? result.data : null
        });
      },
      error => {
        setPunishmentData({
          status: NotApprovedPagePunishmentContextStatus.ERROR,
          error: error as unknown
        });
      }
    );
  }, []);

  return (
    <NotApprovedPagePunishmentContext.Provider value={punishmentData}>
      {children}
    </NotApprovedPagePunishmentContext.Provider>
  );
};

export default NotApprovedPagePunishmentProvider;
